module.exports = __webpack_public_path__ + "img/distance.9f414ae.svg";